import { ProcessPending, SaveProcessPendingCommand } from "../models/ProcessPending";
import api from "./api";

export interface SaveResult {
  success: boolean;
  notifications: string[];
  id?: string;
}

// Erros de rede/HTTP propagam (quem chama mostra o toast); erros de regra vêm em notifications.
export const getProcessPendings = async (processId: string): Promise<ProcessPending[]> =>
  (await api.get(`/api/process/${processId}/pendings`)).data;

export const addProcessPending = async (processId: string, command: SaveProcessPendingCommand): Promise<SaveResult> =>
  (await api.post(`/api/process/${processId}/pendings`, command)).data;

export const updateProcessPending = async (id: string, command: SaveProcessPendingCommand): Promise<SaveResult> =>
  (await api.put(`/api/process/pendings/${id}`, command)).data;

export const deleteProcessPending = async (id: string): Promise<SaveResult> =>
  (await api.delete(`/api/process/pendings/${id}`)).data;
